module.exports = __webpack_public_path__ + "img/visitor.88d74565.png";